import { render, staticRenderFns } from "./HuggingFace.vue?vue&type=template&id=0d281a4b&scoped=true"
import script from "./HuggingFace.vue?vue&type=script&lang=js"
export * from "./HuggingFace.vue?vue&type=script&lang=js"
import style0 from "./HuggingFace.vue?vue&type=style&index=0&id=0d281a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d281a4b",
  null
  
)

export default component.exports